import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {getDescriptionForStandardType} from "./__graphql-types__/index.ts";

// TODO: it would be more efficient if we could generate a single query for all
// of the standard descriptions we need to look up. Or, even better: defer the
// query until the user actual hovers over the item.
export const STANDARD_DESCRIPTION_QUERY: GqlOperation<
    getDescriptionForStandardType["response"],
    getDescriptionForStandardType["variables"]
> = gqlOp(gql`
    query getDescriptionForStandard(
        $region: String!
        $setId: String!
        $standardId: String!
    ) {
        publishedStandard(
            region: $region
            setId: $setId
            standardId: $standardId
        ) {
            id
            description
        }
    }
`);
